import Phaser from 'phaser';
import { BootScene } from './scenes/BootScene';
import { GameScene } from './scenes/GameScene';
import { EditorScene } from './scenes/EditorScene';

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game',
  // Виртуальное разрешение — растягивается до экрана через Phaser.Scale.FIT.
  // 1067×600 = 1280×720 / 1.2 — игра выглядит на 20% крупнее на том же экране.
  width: 1067,
  height: 600,
  backgroundColor: '#1a1a24',
  pixelArt: false,
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { x: 0, y: 1050 },
      debug: false,
      // fixedStep: false — физика использует реальную delta-time, а не фиксированный
      // шаг 16.66мс. Иначе на устройствах с другой частотой кадров (PC 60fps vs
      // iPad ProMotion 120fps) накапливается разное число physics-шагов за dashDuration,
      // и dash едет на разную дистанцию.
      fixedStep: false,
    },
  },
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  input: {
    activePointers: 3, // multitouch: до 3 одновременных касаний (iPad: джойстик + 2 кнопки)
  },
  scene: [BootScene, GameScene, EditorScene],
};

new Phaser.Game(config);
